import React from "react";
import BackLink from "../components/BackLink";
import { Col, Row } from "react-bootstrap";
import JourneyProgress from "../components/JourneyProgress";
import RapidStor from "../components/RapidStor";
import Breadcrumbs from "../components/Questionnaire/Breadcrumbs";
import Location from "../features/rapidstor/entities/Location";
import { useLoaderData } from "react-router-dom";
import Countdown from "../components/Countdown";

function RapidStorPage() {
  const location = useLoaderData() as Location;

  return (
    <>
      <BackLink desktop />
      <Row>
        <Col xs={12}>
          <JourneyProgress mobile className={"mt-2"} />
          <Breadcrumbs location={location} />
          <Countdown minutes={20} seconds={0} />
          <RapidStor location={location} />
        </Col>
      </Row>
    </>
  );
}

export default RapidStorPage;
